import { initialPagination, initialState, makeListReducers } from '@/models/utils';
import { bindServices } from '@/services/api';
import CoreQueries from '@/utils/input/queries';

import { filtersConfig } from './utils';

const namespace = 'accessLog';
const api = bindServices(namespace);

const AccessLogModel = {
  namespace,
  state: {
    ...initialState,
    orderBy: 'created desc',
    filtersConfig,
  },
  effects: {
    *fetchData({ payload }, { call, put, select }) {
      try {
        const pagination = yield select((state) => state[namespace].pagination);
        const pageSize = yield select((state) => state.global.pageSize);
        const params = {
          ...CoreQueries.AccessLog.paged,
          pageSize,
          ...pagination,
          ...payload,
        };
        const res = yield call(api.getAll, {
          route: payload.route ? payload.route : 'userAccessLog/paged',
          params,
          readPriority: true,
        });

        yield put({
          type: 'queryData',
          payload: { ...res, limit: payload.limit ?? pageSize, page: payload.page ?? 1 },
        });
      } catch (e) {}
    },

    *fetchItem({ payload }, { call, put }) {
      try {
        yield put({ type: 'success', payload: false });
        const res = yield call(api.getById, {
          route: 'userAccessLog',
          id: payload.id,
          params: {
            ...(payload.detail ? CoreQueries.AccessLog.itemDetail : {}),
            ...(payload?.params && { ...payload.params }),
          },
        });
        yield put({ type: 'queryItem', payload: res });
      } catch (e) {}
    },

    *setOrderBy({ payload }, { put }) {
      yield put({
        type: 'queryOrderBy',
        payload,
      });
    },

    *showForm({ payload }, { put }) {
      yield put({ type: 'queryShowForm', payload });
    },
  },
  reducers: {
    ...makeListReducers({
      initialPagination,
      initialState: {
        ...initialState,
        filtersConfig,
      },
    }),
  },
};

export default AccessLogModel;
